import FireArrow from "../../../core/assets/oot/gshd/fire-arrows_32x32.png";
import Item from "../../../core/items/Item";
import { ItemLightDto } from "../../../core/items/ItemDataTypes";
import StaticItem from "../../../core/items/StaticItem";
import OotItem, { DbItemProps } from "./OotItem";
import { SimpleItemProps } from "./SimpleItemProps";

let id = "OoT_FireArrow";


const FireArrowItem = () => {


    return <OotItem id={id}>
        {({ updateOotItem, item }) => {
            return <Item id={id} image={FireArrow} title="Fire Arrow" updateItem={updateOotItem} item={item} isMajor />
        }}
    </OotItem>
}

export default FireArrowItem;

export const SimpleFireArrowItem = (props: SimpleItemProps) => {


    return <StaticItem
        image={FireArrow}
        onClick={props.onClick}
        name={id}
    />


}

export const DbFireArrowItem = (props: DbItemProps) => {

    let item = props.items?.filter(x => x.id === id)?.[0] ?? DefaultFireArrowItem;

    return <Item
        item={item}
        updateItem={props.update}
        image={FireArrow}
        id={id}
        title={id}
        isObtained={item.isObtained}
    />


}

const DefaultFireArrowItem : ItemLightDto = {
    img: FireArrow,
    id: id,
    title: id,
    childItem: undefined,
    childItemName: undefined,
    isObtained: false,
    isChecked: false,
    state: 0
}